import * as THREE from 'three';
import { FikoEksen } from '../FikoEksen';
import { FikoGrup } from '../FikoGrup';
import { FikoSahne } from '../FikoSahne';
import { FikoVektor3D } from '../FikoVektor3d';
import { FikoTakim } from './FikoTakim';
import { FikoTakimFrezeleme } from './FikoTakimFrezeleme';
import { FikoTakimYolu } from './FikoTakimYolu';
import { FikoVektorTakimYol3D } from './FikoVektorTakimYol3d';

export class FikoApt extends FikoGrup {
    override type: any = "FikoApt";
    /** */
    sagButonlar: any[] = [
        // {
        //     isim: "",
        //     simge: "eye",
        //     tiklandi: () => {
        //         this.visible = !this.visible;
        //         this.sahne.anaGosterim.ciz();
        //     }
        // },
        {
            isim: "Similasyon Yap",
            simge: "play",
            tiklandi: () => {
                // this.sahne.anaGosterim.DialogFikoSimilasyon.ac(this);
                // this.sahne.anaGosterim.DialogFikoSimilasyon.tiklandiIleriOynat();
            }
        }
    ]

    // parametreler = [{
    //     ismi: "Pozisyon",
    //     turu: "Çubuk",
    //     ayar: {
    //         min: 0,
    //         maks: 1,
    //         adim: 1,
    //     },
    //     degeri: 0,
    //     degisti: () => { },
    // }
    // ]
    /** NOT: */
    // public get strApt(): string {
    //     return this.userData.strApt;
    // }
    // public set strApt(v: string) {
    //     this.userData.strApt = v;

    // }
    /** */
    public get arrayApt(): string[] {
        return this.userData['arrayApt'];
    }
    public set arrayApt(v: string[]) {
        this.userData['arrayApt'] = v;
    }

    public get tarihi(): Date {
        return this.userData['tarihi'];
    }
    public set tarihi(v: Date) {
        this.userData['tarihi'] = v;
    }

    public get programIsmi(): string {
        return this.userData['programIsmi'];
    }
    public set programIsmi(v: string) {
        this.userData['programIsmi'] = v;
    }

    public get kureMerkezi(): boolean {
        return this.userData['kureMerkezi'];
    }
    public set kureMerkezi(v: boolean) {
        this.userData['kureMerkezi'] = v;
    }

    public get operasyonIsmi(): string {
        return this.userData['operasyonIsmi'];
    }
    public set operasyonIsmi(v: string) {
        this.userData['operasyonIsmi'] = v;
    }

    public get eksenKoord(): { x?: FikoVektor3D, y?: FikoVektor3D, z?: FikoVektor3D, o?: FikoVektor3D } {
        return this.userData['eksenKoord'];
    }
    public set eksenKoord(v: { x?: FikoVektor3D, y?: FikoVektor3D, z?: FikoVektor3D, o?: FikoVektor3D }) {
        this.userData['eksenKoord'] = v;
    }

    aktiviteler?: { ismi: string, alt: any[], koordinatlar?: FikoVektorTakimYol3D[], takim?: FikoTakim, takimYonu?: number[], toplamSure?: number }[]

    eksen: FikoEksen;

    takimYolu: FikoTakimYolu = new FikoTakimYolu();

    constructor(public override sahne?: FikoSahne, name?: string) {
        super(sahne);
        this.name = name;

        this.userData['FikoArayuz'].agactaGorunur = true;
        this.userData['FikoArayuz'].listeGoster = false;
        this.userData['FikoArayuz'].simge = "./simgeler/apt.webp";

        // this.userData.FikoParametreler = {};
        // this.userData.FikoParametreler = [
        //     {
        //         ismi: "Pozisyon",
        //         turu: "Çubuk",
        //         ayar: {
        //             min: 0,
        //             maks: 1,
        //             adim: 1,
        //         },
        //         degeri: 0,
        //         degisti: () => { },
        //     }
        // ];
    }



    parcalaStr(aptStr: string[]) {
        this.arrayApt = aptStr
        this.parcala();
    }

    toplamKoodinatSayisi = 0;
    async parcala() {
        this.toplamKoodinatSayisi = 0;
        let lokalArrayApt = Object.assign([], this.arrayApt);
        /** Tarih Alınıyor */
        for (let index = 0; index < 4; index++) {
            const element = lokalArrayApt[index];
            if (element.indexOf("Generated on ") > -1) {
                const tarihRegex: RegExp = new RegExp(/(Generated on.*)\w+/g);
                this.tarihi = new Date(tarihRegex.exec(element)[0].replace("Generated on ", ""))
            };
        }
        lokalArrayApt.splice(0, 4);
        /** Program İsmi */
        this.programIsmi = lokalArrayApt[0].replace("$$ ", "").trim();
        /** Küre Merkezi */
        let mfgStarts = lokalArrayApt.join("\[fikoAyrac]").split(lokalArrayApt[0]).filter((el) => { return el.length > 0 })[0].trim();
        this.kureMerkezi = mfgStarts.indexOf("TOOL CENTER OUTPUT") > -1;
        /** Part Operasyonu İsmi */
        this.operasyonIsmi = /\$\$  .*/.exec(mfgStarts)[0].replace("$$  ", "")
        lokalArrayApt.splice(0, 1);
        /** */
        lokalArrayApt.splice(0, mfgStarts.split("\[fikoAyrac]").length - 1);
        /** Eksen Konum Koordinatları */
        let parsedKoor0 = lokalArrayApt[0].match(/[-+]?\d*\.\d+|\d+/g).map(Number);
        let parsedKoor1 = lokalArrayApt[1].match(/[-+]?\d*\.\d+|\d+/g).map(Number);
        let parsedKoor2 = lokalArrayApt[2].match(/[-+]?\d*\.\d+|\d+/g).map(Number);
        this.eksenKoord = {
            x: new FikoVektor3D(parsedKoor0[0], parsedKoor1[0], parsedKoor2[0]),
            y: new FikoVektor3D(parsedKoor0[1], parsedKoor1[1], parsedKoor2[1]),
            z: new FikoVektor3D(parsedKoor0[2], parsedKoor1[2], parsedKoor2[2]),
            o: new FikoVektor3D(parsedKoor0[3], parsedKoor1[3], parsedKoor2[3])
        }
        lokalArrayApt.splice(0, 5);
        /** Operasyonlar İçin Ayarlama Yapılıyor */
        let count = 0
        for (let index = 0; index < lokalArrayApt.length; index++) {
            const element = lokalArrayApt[index];
            if (!element.startsWith("$$ OPERATION NAME : ")) {
                count += 1;
            } else break;
        }
        lokalArrayApt.splice(0, count);
        /** Operasyonlar Gruplandırılıyor  */
        // console.log(lokalArrayApt)
        let parcalamaAktivite: any[] = [];// lokalArrayApt.join().split(/(\$\$ OPERATION NAME.*)/);
        this.aktiviteler = [];

        let baslangic = 0;
        for (let i = 0; i < lokalArrayApt.length; i++) {
            let element;
            lokalArrayApt[i] = lokalArrayApt[i].replace(/\n/g, '');
            element = lokalArrayApt[i].replace(/\n/g, '')
            if (element.startsWith("$$ OPERATION NAME : ")) {
                parcalamaAktivite.push(lokalArrayApt.slice(baslangic, i));
                let akt = {
                    ismi: lokalArrayApt[baslangic].replace("$$ OPERATION NAME : ", "").trim(),
                    alt: lokalArrayApt.slice(baslangic, i)
                }
                this.aktiviteler.push(akt)
                baslangic = i;
            } else if (i == lokalArrayApt.length - 1) {
                parcalamaAktivite.push(lokalArrayApt.slice(baslangic, i));
                let akt = {
                    ismi: lokalArrayApt[baslangic].replace("$$ OPERATION NAME : ", "").trim(),
                    alt: lokalArrayApt.slice(baslangic, i)
                }
                this.aktiviteler.push(akt)
            }
        }
        this.aktiviteler.splice(0, 1);
        // console.log(this.aktiviteler)


        // for (let index = 0; index < parcalamaAktivite.length; index += 2) {
        //     const element = parcalamaAktivite[index];
        //     this.aktiviteler.push({
        //         ismi: element.replace("$$ OPERATION NAME : ", "").trim(),
        //         alt: parcalamaAktivite[index + 1]
        //     })
        // }

        /** Koordinatlar İçin Dolaşma Başlıyor */
        let sonDevir: number = null;
        let sonIlerleme: number = null;
        let sonTakimYonu = [0, 0, 1];
        let sonTakim: FikoTakim = null;
        for (let index = 0; index < this.aktiviteler.length; index++) {
            const element = this.aktiviteler[index];

            element.toplamSure = 0;
            if (!element.koordinatlar) element.koordinatlar = [];
            for (let i = 0; i < element.alt.length; i++) {
                const hrkt: string = element.alt[i];

                if (hrkt.startsWith("CUTTER/")) {
                    sonTakim = this.takimAyikla(element);
                } else if (hrkt.startsWith("TLAXIS/")) {
                    sonTakimYonu = this.takimYonuAyikla(hrkt);
                } else if (hrkt.startsWith("SPINDL")) {
                    sonDevir = this.devirAyikla(hrkt);
                } else if (hrkt.startsWith("FEDRAT")) {
                    sonIlerleme = this.ilerlemeAyikla(hrkt);
                } else if (hrkt.startsWith("GOTO")) {
                    const parsedKoor = hrkt.match(/[-+]?\d*\.\d+|\d+/g).map(Number);

                    let renk = new THREE.Color("chartreuse");
                    if (sonIlerleme >= 10000) {
                        renk = new THREE.Color("red");
                    }
                    if (sonIlerleme == 5000) {
                        renk = new THREE.Color("chartreuse");
                    }
                    if (sonIlerleme <= 3000) {
                        renk = new THREE.Color("blue");
                    }
                    if (sonIlerleme <= 2500) {
                        renk = new THREE.Color("yellow");
                    }

                    element.takim = sonTakim;

                    let _poz = new FikoVektorTakimYol3D(parsedKoor[0], parsedKoor[1], parsedKoor[2]);
                    // let wrldNokta = new FikoVektorTakimYol3D(this.localToWorld(_poz.clone()).x, this.localToWorld(_poz.clone()).y, this.localToWorld(_poz.clone()).z)

                    let _takimYolu = _poz;
                    _takimYolu.hiz = sonIlerleme;
                    _takimYolu.devir = sonDevir;
                    _takimYolu.renk = renk;

                    _takimYolu.takim = sonTakim;

                    _takimYolu.takimYonu.set(sonTakimYonu[0], sonTakimYonu[1], sonTakimYonu[2]);

                    _takimYolu.ekBilgiler = element;
                    _takimYolu.ekBilgiler.programIsmi = this.programIsmi;
                    element.koordinatlar.push(_takimYolu);
                    this.toplamKoodinatSayisi += 0
                }
            }
            element.takimYonu = sonTakimYonu;
            // element.alt = undefined;
        }

        // this.strApt = undefined;

        this.name = this.programIsmi;


        this.takimYoluEkle();

        lokalArrayApt = undefined;
    }


    devirAyikla(aptLine: string): number {
        return aptLine.match(/[-+]?\d*\.\d+|\d+/g)?.map(Number)[0];
    }

    ilerlemeAyikla(aptLine: string): number {
        return aptLine.match(/[-+]?\d*\.\d+|\d+/g)?.map(Number)[0];
    }

    takimAyikla(toolChangeAktivite: any) {

        for (let s = 0; s < toolChangeAktivite.alt.length; s++) {
            const satir = toolChangeAktivite.alt[s];
            if (satir.startsWith("CUTTER/")) {
                const line = String(toolChangeAktivite.alt[s] + toolChangeAktivite.alt[s + 1]).replace("$", "").replace("CUTTER/", "");
                toolChangeAktivite.takimOlculer = { olculer: line.match(/[-+]?\d*\.\d+|\d+/g)?.map(Number) };
            }

        }

        return new FikoTakimFrezeleme(this.sahne, toolChangeAktivite.takimOlculer.olculer[0], toolChangeAktivite.takimOlculer.olculer[1], 200, toolChangeAktivite.takimOlculer.olculer[toolChangeAktivite.takimOlculer.olculer.length - 1]);
    }

    takimYonuAyikla(aptLine: string) {
        return aptLine.match(/[-+]?\d*\.\d+|\d+/g).map(Number);
    }

    async takimYoluEkle() {
        let _toplamSure: number = 0;
        /** NOT: O İşlemleri Burada Yap */
        this.takimYolu.name = this.programIsmi + ".FikoTakimYolu";

        this.takimYolu.noktalar = [];

        this.takimYolu.position.copy(this.eksenKoord.o);
        this.takimYolu.setRotationFromMatrix(new THREE.Matrix4().makeBasis(this.eksenKoord.x, this.eksenKoord.y, this.eksenKoord.z))

        // this.takimYolu.agactaGorunur = false;

        this.ekle(this.takimYolu);

        // this.takimYolu.updateMatrix();
        // this.takimYolu.updateMatrixWorld(true);
        this.takimYolu.updateWorldMatrix(true, true);


        let birlesikNoktalar: FikoVektorTakimYol3D[] = new Array<FikoVektorTakimYol3D>(this.toplamKoodinatSayisi);
        let sonPoz = 0;
        for (let index = 0; index < this.aktiviteler.length; index++) {
            const element = this.aktiviteler[index];

            // birlesikNoktalar.length = birlesikNoktalar.length + element.koordinatlar.length;
            for (let ikoor = 0; ikoor < element.koordinatlar.length; ikoor++) {
                const koor = element.koordinatlar[ikoor];
                birlesikNoktalar[sonPoz] = koor;
                /** */
                const _localNokta = birlesikNoktalar[sonPoz];

                const ltw = this.takimYolu.localToWorld(_localNokta.clone())
                let wrldNokta = new FikoVektorTakimYol3D(ltw.x, ltw.y, ltw.z)
                let _localYon = _localNokta.takimYonu.clone().transformDirection(this.takimYolu.matrixWorld.clone());

                _localNokta.takimYonu = _localYon;

                _localNokta.copy(wrldNokta);

                if (sonPoz > 0) {
                    const hesap = (birlesikNoktalar[sonPoz - 1].distanceTo(_localNokta) / (_localNokta.hiz / 60))
                    // _toplamSure += hesap;
                    // _localNokta.guncelSure = birlesikNoktalar[sonPoz - 1].guncelSure + hesap;

                    _toplamSure += hesap != Infinity ? hesap : 0;
                    _localNokta.guncelSure = hesap != Infinity ? _localNokta.guncelSure + hesap : _localNokta.guncelSure;

                }

                this.takimYolu.noktalar.push(_localNokta);
                /** */
                sonPoz += 1;
            }
            // birlesikNoktalar = birlesikNoktalar.concat(element.koordinatlar);
        }

        // console.log(birlesikNoktalar.length)
        for (let k = 0; k < birlesikNoktalar.length; k++) {
            const element = birlesikNoktalar[k];
            element.toplamSure = _toplamSure;
        }

        // this.takimYolu.noktalar = birlesikNoktalar;


        // for (let i = 0; i < birlesikNoktalar.length; i++) {
        //     const _localNokta = birlesikNoktalar[i];

        //     const ltw = this.takimYolu.localToWorld(_localNokta.clone())
        //     let wrldNokta = new FikoVektorTakimYol3D(ltw.x, ltw.y, ltw.z)
        //     let _localYon = _localNokta.takimYonu.clone().transformDirection(this.takimYolu.matrixWorld.clone());

        //     _localNokta.takimYonu = _localYon;

        //     _localNokta.copy(wrldNokta);

        //     if (i > 0) {
        //         const hesap = (birlesikNoktalar[i - 1].distanceTo(_localNokta) / (_localNokta.hiz / 60))
        //         // _toplamSure += hesap;
        //         _localNokta.guncelSure = birlesikNoktalar[i - 1].guncelSure + hesap;

        //     }

        //     // _localNokta.toplamSure = _toplamSure;
        //     // if (this.takimYolu.noktalar.length > 0)
        //     //     _toplamSure += (this.takimYolu.noktalar[this.takimYolu.noktalar.length - 1].distanceTo(_localNokta) / (_localNokta.hiz / 60));


        //     this.takimYolu.noktalar.push(_localNokta);
        // }

        // this.userData.FikoParametreler[0].ayar.maks = this.takimYolu.noktalar.length;
        // this.userData.FikoParametreler[0].degisti = () => {
        //     this.takimYolu.takimYoluPozisyonDegisti(this.userData.FikoParametreler[0].degeri); this.sahne.anaGosterim.ciz();

        // };
    }

    ciftTiklandi() {
        // this.sahne.anaGosterim.DialogFikoApt.ac(this);
    }

    sagTiklandi() {
    }

    override toJSON(meta?: { geometries: any; materials: any; textures: any; images: any }): any {
        const _rslt: any = super.toJSON(meta as any);
        // Children'lari (FikoTakimYolu) ayri olarak serialize et
        // super.toJSON children'i THREE.js formatinda serialize ediyor, biz kendi formatimizi kullanalim
        _rslt.children = [];
        for (let i = 0; i < this.children.length; i++) {
            const child = this.children[i];
            if ((child as any).toJSON) {
                _rslt.children.push((child as any).toJSON());
            }
        }
        return _rslt;
    }

    static fromJson(sahne?: FikoSahne, parent?: any, json?: any) {
        const mtrx = json.matrix;
        const children = json.children || [];
        delete json.matrix;
        delete json.children;
        const _rslt: FikoApt = Object.assign(new FikoApt(sahne), json);
        _rslt.matrix.fromArray(mtrx);
        _rslt.layers = new THREE.Layers();
        _rslt.layers.set(json.layers);
        _rslt.parent = parent;

        // Oncelik 1: Eger children varsa (FikoTakimYolu JSON) onlari yukle
        if (children.length > 0) {
            for (const childJson of children) {
                // FikoApt children'lari her zaman FikoTakimYolu
                if (childJson.type === 'FikoTakimYolu') {
                    const child = FikoTakimYolu.fromJson(sahne, _rslt, childJson);
                    if (child) {
                        _rslt.ekle(child);
                    }
                }
            }
        }
        // Oncelik 2: Eger children yoksa ama arrayApt varsa, parcala ile olustur
        else if (_rslt.arrayApt?.length > 0) {
            _rslt.parcala();
        }

        return _rslt;
    }
}